import { getStoredMapMode, getStoredMapStyle, setStoredMapMode, setStoredMapStyle } from "@components/world-map/world-map-utils";
import { createSlice } from "@reduxjs/toolkit";
import { LocalStorageUtils } from "@utils/local-storage-utils";
import { getDataViewMode } from "@store/ui/ui-slice-utils";
export const initialState = {
  dataViewMode: getDataViewMode(),
  sidebar: {
    isFullSize: LocalStorageUtils.getBooleanItem("is-sidebar-full-size") ?? true,
    isOpenOnMobile: false,
    isVisible: false
  },
  search: {
    debouncedSearchText: "",
    isDebouncingSearch: false,
    pathname: null
  },
  // We first check the local storage so that we don't have to provide all the time the query param.
  isHideMigratedWorkspacesEnabled: LocalStorageUtils.getBooleanItem("is-hide-migrated-workspaces-enabled") ?? false,
  numUnreadMsg: 0,
  worldMapStyle: getStoredMapStyle(),
  worldMapMode: getStoredMapMode()
};

/**
 * Slice to access state of ui
 */
const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setDataViewMode(state, action) {
      state.dataViewMode[action.payload.subject] = action.payload.viewMode;
      LocalStorageUtils.setJSONItem("data-view-mode", state.dataViewMode);
    },
    setIsHideMigratedWorkspacesEnabled(state, action) {
      LocalStorageUtils.setBooleanItem("is-hide-migrated-workspaces-enabled", action.payload);
      state.isHideMigratedWorkspacesEnabled = action.payload;
    },
    setNumUnreadMsg(state, action) {
      state.numUnreadMsg = action.payload;
    },
    updateSidebar(state, action) {
      state.sidebar = {
        ...state.sidebar,
        ...action.payload
      };
      if (action.payload.isFullSize !== undefined) {
        LocalStorageUtils.setBooleanItem("is-sidebar-full-size", state.sidebar.isFullSize);
      }
    },
    setDebouncedSearchText(state, action) {
      state.search.debouncedSearchText = action.payload;
    },
    /** Clears the search text and records the page that any new search text belongs to */
    resetSearchText(state, action) {
      state.search.debouncedSearchText = "";
      state.search.pathname = action.payload;
    },
    setIsDebouncingSearch(state, action) {
      state.search.isDebouncingSearch = action.payload;
    },
    /** Sets the map style in both the redux state and local storage */
    setWorldMapStyle(state, action) {
      setStoredMapStyle(action.payload);
      state.worldMapStyle = action.payload;
    },
    /** Sets the map mode (2D/3D) in both the redux state and local storage */
    setWorldMapMode(state, action) {
      setStoredMapMode(action.payload);
      state.worldMapMode = action.payload;
    },
    resetUiState: () => initialState
  }
});
export const {
  setDataViewMode,
  setIsHideMigratedWorkspacesEnabled,
  setNumUnreadMsg,
  updateSidebar,
  setDebouncedSearchText,
  resetSearchText,
  setIsDebouncingSearch,
  setWorldMapStyle,
  setWorldMapMode,
  resetUiState
} = uiSlice.actions;
export const uiReducer = uiSlice.reducer;